/* eslint-disable import/no-duplicates */
import parseWithOptions from 'date-fns/fp/parseWithOptions';
import { startOfToday } from 'date-fns';
import { ru } from './locale';
export const parse = parseWithOptions({
  locale: ru
}, startOfToday());